import Validation from './src/main.js';

export default Validation;
